// extracted by mini-css-extract-plugin
export default {"container":"loginPage_container__i5vBj","message":"loginPage_message__H09NY"};